/* LUX-MM — keyboard + top-offset only.
   Hover show/hide is CSS-driven (parent <li>:hover + Horizon's aria-expanded).
   This JS owns: ESC close, ArrowDown into panel, first-letter typing on Designers,
   dynamic --lux-mm-top-offset to keep panel flush with header bottom.
   No deps. */
(function () {
  'use strict';

  // ============ TOP OFFSET SYNC ============
  function syncTopOffset() {
    var header = document.getElementById('header-component')
      || document.querySelector('header-component')
      || document.querySelector('.header, header.header, [data-header-component]');
    if (!header) return;
    var rect = header.getBoundingClientRect();
    var offset = rect.bottom;
    if (offset > 0 && offset < 400) {
      document.documentElement.style.setProperty('--lux-mm-top-offset', offset + 'px');
    }
  }

  // ============ KEYBOARD: ESC + ArrowDown + first-letter ============
  document.addEventListener('keydown', function (e) {
    var trigger = e.target && e.target.nodeType === 1 ? e.target.closest('[data-mm-trigger]') : null;

    if (trigger) {
      var id = trigger.getAttribute('aria-controls');
      var panel = id ? document.getElementById(id) : null;
      if (!panel) return;

      if (e.key === 'ArrowDown' || e.key === ' ') {
        e.preventDefault();
        // Let Horizon's activate also fire — we just move focus into panel.
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        var first = panel.querySelector('a');
        if (first) first.focus();
      } else if (e.key === 'Escape') {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
      }
      return;
    }

    var insidePanel = e.target && e.target.nodeType === 1 ? e.target.closest('.lux-mm__panel') : null;
    if (insidePanel) {
      if (e.key === 'Escape') {
        e.preventDefault();
        var t = document.querySelector('[aria-controls="' + insidePanel.id + '"]');
        insidePanel.classList.remove('is-open');
        insidePanel.setAttribute('aria-hidden', 'true');
        if (t) {
          t.setAttribute('aria-expanded', 'false');
          t.focus();
        }
        return;
      }

      // First-letter typing on Designers panel only
      if (insidePanel.id === 'mm-panel-designers' && e.key && e.key.length === 1 && /[a-zA-Z]/.test(e.key)) {
        var letter = e.key.toLowerCase();
        var links = insidePanel.querySelectorAll('a.lux-mm__link');
        var currentFocus = document.activeElement;
        var startIndex = 0;
        for (var i = 0; i < links.length; i++) {
          if (links[i] === currentFocus) { startIndex = i + 1; break; }
        }
        var found = null;
        for (var j = 0; j < links.length; j++) {
          var idx = (startIndex + j) % links.length;
          var txt = (links[idx].textContent || '').trim().toLowerCase();
          if (txt.charAt(0) === letter) { found = links[idx]; break; }
        }
        if (found) { e.preventDefault(); found.focus(); }
      }
    }
  });

  function init() {
    syncTopOffset();
    window.addEventListener('resize', syncTopOffset);
    window.addEventListener('scroll', function () { syncTopOffset(); }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
